module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("CHAPTER TWO")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_vm._v("‘I "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("SUGGEST")])]), _vm._v(" we put the baby back to bed and you can tell me what the hell you’re talking about!’ Nick rasped now, his mouth tight.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini could completely sympathise with his feelings. Fifteen months ago Nick had been her sister Jemima’s fiancé, a little fact her sister seemed to have forgotten when she’d seen someone else that she wanted! And her engagement to Nick hadn’t been the only thing Jemima had conveniently forgotten!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Shouldn’t I feed the baby first?’ she prompted uncertainly; after all, it was now four hours since Jessica’s last feed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Hardly!’ Nick gave a pointed look at the sleeping baby.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini could feel that heated colour enter her cheeks once again. Damn it, she was usually so cool and in control, especially around Nick, who was always so competent himself; it was totally unfair that she found herself in this unfamiliar role with him as a witness!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And she didn’t feel any more comfortable with the situation as the two of them placed the baby back into her carrycot and arranged the blankets over her. They looked like a pair of doting parents, for goodness’ sake—and, considering the sterile state of their marriage, that was something they would never be!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Time for a brandy, I think,’ Nick muttered grimly once they had settled the baby back in her cot in the spare bedroom.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("‘I’ll just get my robe,’ Gemini told him lightly, ever con")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("scious of the fact that she was only wearing the milk-stained pyjamas.")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nick gave her a mocking sideways glance. ‘I’ve seen women in less, Gemini,’ he drawled derisively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She flicked her hair back, her chin raised haughtily. ‘Not me, you haven’t,’ she snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘True,’ he murmured mockingly. ‘But it’s a fact you are my wife…’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She knew what she was. Didn’t need any reminding. Nor did she need to be reminded of the fact that there had been other women in Nick’s life before he married her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And since…?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d tried over recent months not to think too deeply about Nick’s private life. Before that it hadn’t occurred to her to think about it; it was only lately she had begun to wonder—")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No! These were thoughts that took her nowhere—except to sleepless nights as she lay torturing herself with wondering whether or not Nick really "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" away on business, or if there could be some other reason, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("someone,")]), _vm._v(" who kept him away from home for days at a time!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was an aspect of their marriage they hadn’t discussed when they’d decided to marry each other fourteen months ago. It hadn’t occurred to Gemini at the time to discuss it; if she’d thought about it she’d probably assumed that Nick would make his own arrangements. It was only in recent months that Gemini had found herself thinking about that side of his life too…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because, as she knew only too well, Nick was a very attractive man, and it would be ridiculous to assume that he had remained celibate during their marriage. And it certainly hadn’t been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(" he was making love to…!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("Damn it, she didn’t want to think about that, had no right to do so. They had married each other for their own rea")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("sons, and they weren’t reasons that allowed for interference in each other’s private lives.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nick had poured the brandies when Gemini joined him in the sitting-room, its gas-flame fire adding a cheeriness to the room. Which was just as well, because Nick’s grim expression wasn’t in the least cheering!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘So, true to form, Jemima has done it again—only this time she’s dumped her baby on you?’ he rasped without preamble.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not exactly.’ Gemini grimaced, taking her glass of brandy to sip it gratefully; she should have guessed Nick would get straight to the point! ‘What I mean is that, yes, Jessica has been brought here, but it wasn’t by Jemima. You see—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No—I don’t see,’ he cut in with icy disdain. ‘But then, where your irresponsible sister is concerned—does anybody?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini wasn’t even going to attempt to defend her twin sister. She simply couldn’t imagine two people more unalike than Jemima and herself; Jemima roamed the world in search of the latest scoop, very rarely in the same place for any length of time, whereas Gemini had lived in London all of her life, dedicatedly etching out a career for herself in the world of fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("No, she couldn’t say she understood her twin’s need for travel and excitement, but by the same token she "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" her sister…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Jemima is in America,’ she told Nick evenly. ‘The young lady she engaged as Jessica’s nanny is going to be married tomorrow, and so obviously she can’t look after her at the moment—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Obviously,’ Nick acknowledged disgustedly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini drew in a deep, controlling breath, knowing his anger was well merited; Jemima was going to hear exactly what she thought of her when she returned. When…!")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But the nanny has assured me that Jemima should be back on Monday,’ she added, more with hope than any degree of certainty; if Jemima didn’t have her story by then, there was no telling when she would be back!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘And so she’s left you here holding her baby—literally?’ Nick dismissed scathingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She frowned. ‘Admittedly, it’s a little inconvenient—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Inconvenient!’ Nick echoed, shaking his head disgustedly. ‘Considering the two of you haven’t even spoken for well over a year, I find the whole thing incredible. I won’t say unbelievable—because nothing your sister does surprises me any more!’ he added grimly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He still cared, Gemini realised with dismay. It had been almost fifteen months since Jemima had broken her engagement to him so thoughtlessly, but it was obvious from the bitterness Nick was showing now that the insult had been far from forgotten. Or forgiven…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And why should it be—wasn’t it for that very reason that she and Nick were now married to each other…?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nick’s romance with Jemima had happened so suddenly and so quickly, sixteen months ago, that it had only been at the dinner to celebrate their engagement that the two of them had been introduced to each other’s families. Both sets of parents were dead, and so it was left to Gemini, as Jemima’s sister, and Danny, Nick’s younger brother, to represent what little family there was left.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini had been sceptical about the suddenness of the romance, believing it to be just another of Jemima’s rash—and usually disastrous!—impulses. But to her surprise Nick Drummond had turned out to be exactly the sort of man every mother would wish their daughter to meet and marry: obviously wealthy, very handsome, with an arrogance that protected all of those close to him. And, as Nick’s future wife, Jemima had definitely come into that category.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("The only problem Gemini had been able to see with the ")]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("match had been that if anything Nick was just too perfect, too arrogant, too much in control of himself and those around him. Jemima, on the other hand, had been ten years younger than her new fiancé, full of fun and life, eager for excitement and adventure.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But the four of them had enjoyed a pleasant dinner together. Danny Drummond was ten years younger than his brother, a professional naturalist photographer who worked freelance for several well-known magazines. He was completely different from his brother in looks, a little under six feet in height, with overlong blonde hair and laughing brown eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What should have been apparent to all of them that night was that Danny was also full of fun and life, eager for excitement and adventure…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini had been bowled over by him, fascinated by his stories of trekking through Africa in his search for wildlife pictures that would appeal to others as well as himself, and at the end of the evening she’d been only too happy to accept his invitation for the two of them to have dinner together the following evening.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There had followed a month in Gemini’s life the like of which she had never known before. Danny was completely unconventional; their dates had been equally so. Danny had even whisked her off to a Scottish island for the weekend on one occasion—because he’d wanted to film the birdlife there.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini had been enthralled, enraptured, her own life and career put on hold every time Danny made one of his unannounced appearances. But it had all come to an abrupt end the day she had visited Danny’s apartment and found Jemima there with him…!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("She looked across at Nick now, remembering all too clearly the humiliated anger they had both felt at learning ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("that her sister and his brother had been indulging in a little relationship of their own behind their backs…")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I should have known, damn it,’ Nick muttered to himself now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini gave him a puzzled look. ‘Should have known what?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked as if he were about to explode with anger. ‘Jemima called me today—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Jemima did?’ Gemini cut in angrily; the last she had heard of Jemima and Nick’s friendship they hadn’t even been talking to each other! And now it appeared Jemima was telephoning him…!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He nodded. ‘On my mobile. Apparently she tried to call the house this morning—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I was out shopping,’ Gemini said dazedly. Her sister had called Nick on his mobile…! For the first time in the last year. Or had Jemima contacted him before in this way?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nick’s mouth twisted. ‘And Mrs James was away for the day,’ he realised. ‘Jemima wanted to know if we would be at home this weekend. I assured her that we would,’ he said grimly. ‘I had no idea the reason she wanted to know was because she intended dumping her baby here!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Well, at least Jemima’s telephone call to Nick proved that her sister wasn’t quite as irresponsible as she had thought her to be; at least she had ascertained that someone would be at home before Jessica was brought here!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But what else did it mean…? Was Jemima in the habit of calling Nick on his mobile? Despite the fact he was her husband, Gemini simply didn’t have the sort of relationship with Nick that would allow her to ask him such a question.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If it’s not too stupid a question—who the hell is the father?’ Nick rasped, with a return of that cold, remorseless anger that had become such a part of him fifteen months ago on learning of Jemima and Danny’s duplicity.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("And the question wasn’t so unreasonable, either—be")]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("cause two months after Jemima had broken her engagement to Nick, because she’d supposedly been in love with Danny, she and Danny had also parted!")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it had been too late then for any second thoughts on Gemini or Nick’s part—because they had already been married to each other…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wasn’t naturally impulsive by nature—she believed Jemima must have inherited all that part of their character at their birth—but at the time there had been no doubt in Gemini’s mind that she had fallen in love with Danny Drummond, hook, line and sinker. Only to find that he had been having an affair with Jemima almost from the very first evening they had all been introduced!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini had been devastated by both Danny and Jemima’s behaviour. Nick’s reaction to his brother and fiancée’s duplicity had been much less predictable—he’d asked Gemini to marry him!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her initial reaction to the proposal had been one of disbelief. And a questioning as to why, after being hurt so badly, she should want to marry anyone!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But even as she had asked herself that question she had known the answer all too clearly; all of her friends and business acquaintances had known of her relationship with Danny, of how for one wild, impetuous month she had put the rest of her life on hold to be with him—even GemStone had taken second place to the relationship for a while. She was going to look a complete idiot, both privately and professionally, when it became public knowledge that Danny had actually preferred her sister!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("But she’d been sure Nick couldn’t be serious about the proposal, that it was just a knee-jerk reaction to Jemima’s betrayal. But he was quite serious, Nick had assured her grimly. Why shouldn’t they marry each other? They were both adults, and falling in love had proved a humiliating experience for both of them. And he was thirty-eight, he’d ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("stated, it was time he had a wife, and Gemini, successful, self-assured, wise now to the stupidity of falling in love, would make him a very good one. And she, he’d claimed, would gain a husband who made no emotional demands on her, who was proud of her achievements and, most importantly of all, would never hurt or humiliate her in the way Danny had.")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had been this last claim, a brutal reminder of how ridiculous she was going to look to the outside world, and feeling still deeply wounded by the hurt Danny and Jemima had inflicted on her, that had made her make the last impulsive decision of her life and say yes!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nick had kept to his word, and their marriage of fourteen months was undoubtedly a success in all that it had set out to be. Gemini was there as Nick’s partner and hostess if he should need one, and Nick was there for her in the same guise. And the existence of their marriage had completely taken away any public sting of humiliation they might have encountered after the end of their relationships with Danny and Jemima. To all intents and purposes it had looked as if the two of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("them")]), _vm._v(" had been the ones to realise they had previously made a mistake, and those mistakes had been rectified by the two of them marrying each other.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Yes, their marriage had succeeded in everything it had set out to do. Gemini had long ago recovered from the hurt Danny had so selfishly inflicted on her heart, having realised it had been a brief infatuation. It was hardly Nick’s fault if she was now fully aware—inwardly, at least!—of her magnetic attraction to the man who was now her husband.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And now Jemima, selfish, uncaring Jemima, had calmly delivered her six-week-old baby into the marriage!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("Gemini shook her head now in answer to Nick’s question concerning Jessica’s father. ‘I have no idea,’ she sighed. ‘But the nanny who delivered the baby here earlier this ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("evening didn’t mention any man being involved,’ she added with a frown.")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not for some months, at least,’ Nick bit out contemptuously. ‘I can’t believe I was ever stupid enough to believe I actually loved the woman!’ he added self-disgustedly before throwing the brandy to the back of his throat, seemingly unmoved as the fiery liquid hit his stomach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini winced. Not because she didn’t feel the same anger towards Jemima for this last thoughtlessness, but because she could no longer bear the thought of Nick ever having been in love with Jemima…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Quite how these possessive feelings towards her own husband had occurred Gemini wasn’t aware, but she had found in recent months that what had begun as a purely business arrangement was no longer so. At least on her part.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Nick’s angry response to Jemima’s latest escapade seemed to imply he was still in love with her sister.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘How can the two of you be identical to look at and yet be so unalike in temperament?’ he added with a disbelieving shake of his head.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Jemima was beautiful, warm and funny, if irresponsible. Gemini, as the eldest twin, if only by minutes, was more serious, coolly detached and self-assured, and dedicated to promoting her own fashion label.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And it was obvious which of them Nick found the most attractive!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("God, how that hurt. How could she have been stupid enough to fall in love with her own husband?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("Because that was exactly what she’d done. She wasn’t even sure when or how; she only knew that she had, that every time he was at home she was totally aware of him, that she found the way he looked physically attractive, that she admired the successful way he ran his business empire. In fact, she loved everything about him! And at the same time she knew that he felt no more for her now than he ")]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("had when he had first proposed this sterile marriage fourteen months ago…")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini stood up abruptly. ‘I don’t think getting into a character assassination—’ or otherwise! ‘—is going to help the situation,’ she told Nick briskly, smoothing down the silkiness of her grey silk robe, very aware of the fact that she had cleansed her face before going to bed and so consequently wore no make-up, that her hair was probably in disarray too.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("In fact, she probably looked a fright! And the one thing she had been very decided on, when accepting Nick’s proposal of marriage, was that she would always make sure to keep her end of their bargain, that she would never be less than the beautiful showpiece and perfect hostess that he wanted in his marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nick’s mouth twisted. ‘You’re probably right—talking about the flaws in Jemima’s character could take all night!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Gemini had no wish to talk about her sister for the rest of the night. In fact, she had no real wish to talk about her sister at all. It was bad enough that she knew Nick still felt so strongly towards Jemima, without the two of them talking about her too!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘In that case,’ she said coolly, ‘I suggest the two of us get back to bed—’ She broke off as Nick looked across at her with dark brows raised speculatively. ‘Separately, of course,’ she bit out tersely.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course,’ he drawled derisively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini glared at him. ‘I’m tired, and not a little irritable; this certainly isn’t the time for your warped sense of humour, Nick,’ she snapped resentfully—because a part of her so wished he weren’t joking at all.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d been aware the whole time they were talking that Nick was naked under that black silk robe, and just the thought made her ache!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("It wasn’t difficult to see that his shoulders were wide, ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("his body leanly muscled, and she could see the dark hair that grew on his chest, and the bareness of his legs beneath the robe. Just looking at him made Gemini’s knees tremble with a need she had never known before! With anyone…")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Strange, she had believed herself to be so much in love with Danny fifteen months ago. But after being Nick’s wife for over a year she couldn’t even remember what Danny looked like, let alone what it had felt like to be with him…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Nick’s was such a strong personality, and he had so much physical presence, that when he wasn’t at home the house seemed strangely empty, only coming alive again when he returned. As it had tonight…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sorry.’ He grimaced now at her rebuke, running a hand through the dark thickness of his hair. ‘I— What is it?’ he prompted sharply at her indrawn breath.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("How on earth could she possibly tell the man who was her husband that she longed to run "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("her")]), _vm._v(" hands through the darkness of his hair, that she wanted to lie in bed next to him looking down at him, to kiss every part of him, to know the full pleasure she was sure Nick was capable of giving her; that she wanted to give him pleasure in return!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was no way she could ever let him even see she felt that way, let alone tell him such a thing!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Nothing,’ she snapped abruptly. ‘I told you, I’m tired.’ She relented slightly as he raised dark brows at her unaccustomed aggression. He could hardly be blamed—or even know!—that the frustrated irritation she always felt nowadays when he was at home had returned. ‘Did you have a good business trip?’ she prompted as she moved to switch off some of the lamps prior to going to bed.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shrugged. ‘It was the usual round of business meetings,’ he dismissed in a bored voice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("‘It can’t have been all business, Nick.’ She attempted to tease him, still deeply troubled by the way Jemima had ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("telephoned him—and whether or not it was something that had happened before!")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked across at her with intense green eyes, not answering her for several minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Gemini couldn’t help wondering if she had given herself away. Had her tone not been as teasing as she had meant it to be? Worse, had she sounded like a suspicious wife?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She hoped not; it was something she knew Nick would never tolerate. He never questioned her when she came back from buying trips, never showed the slightest interest in what she did on a social level while she was away from home.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Damn him!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Okay, so she wasn’t Jemima, but the two of them were identical to look at, and before she’d known the Drummond brothers there had never been any shortage of men wanting to take her out, to tell her she was beautiful, desirable. Nor since, if she were honest…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("So why didn’t Nick find her attractive?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d asked herself that question so many times during recent months, and the only answer she had been able to come up with was that it was because she and Jemima "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("were")]), _vm._v(" identical, and in Nick’s eyes maybe she was only a pale copy of her twin sister.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now that hurt!")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("Because she was a person in her own right. When they were children their mother had always dressed the two girls the same, styled their dark hair the same way, so much so that they had simply become known as ‘the Stone twins’. But adulthood had brought deliberate changes, and the two women’s styles of dress were now completely different. Jemima favoured jeans and tee shirts, while Gemini’s clothes were always stylish and elegant. Jemima kept her ")]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_vm._v("hair cropped short for convenience’s sake; Gemini preferred a softer, shoulder-length style.")])]), _c('a', {
    attrs: {
      "id": "page30"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But Gemini knew she had to accept the fact that in Nick’s eyes it was the differences in their personalities that left her wanting…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No, not all business, Gemini,’ he finally answered her slowly, still watching her with narrowed eyes. “‘All work and no play”, and all that rubbish…’ he added derisively.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She swallowed hard, not knowing if she wanted to go on with this conversation but also knowing it was too late to stop now! ‘And in what way do you “play” while you’re away, Nick?’ She hoped she had managed to make her tone sound light and uninterested this time! Sound it—because it was far from the way she felt; her hands were clenched so tightly at her sides that her nails were sticking into the palms of her hands.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He bent to switch off the gas fire before answering her. To give him time to think of a suitable answer? One that would be acceptable to a wife? His wife?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But then she was his wife in name only, and not even that really. Her fashion label GemStone meant that most people still assumed her name was Gemini Stone, and not Drummond at all…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I spent a lot of time in the hotel pool,’ he finally drawled, his green gaze meeting hers challengingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Because he couldn’t have spent every evening in the swimming pool, and they both knew it! But to pursue this subject any further would surely be dangerous on her part; Nick would want to know the reason for her interest, and there was no way she could tell him it was jealousy of the time he spent with anyone else but her! Especially if that ‘anyone’ should turn out to be Jemima!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘That must have been nice.’ She nodded, turning to leave.")])]), _c('a', {
    attrs: {
      "id": "page31"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Er—Gemini…?’ Nick stopped her as she reached the door.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She froze, turning slowly back to face him. Had she given herself away, after all? She could read nothing from his closed expression. ‘Yes?’ she prompted warily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I hope you don’t mind, but I’ve accepted a dinner invitation for the two of us with the Crawfords tomorrow evening,’ he drawled pointedly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The point was completely lost on her! Why should he think that would be a problem for her? She was always more than happy to go out with Nick. In fact, she looked forward to the evenings they would be out together in public; Nick was always the attentive husband on such occasions, and even though she knew it was a façade she still revelled in his protective care!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Jessica…?’ Nick reminded her as she continued to look blank. ‘I don’t think it would be quite the thing to take her along with us—do you?’ he added mockingly.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The baby! She’d done it again, Gemini realised; of course, they would need a babysitter for Jessica if the two of them were to go out together!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Perhaps Mrs James…?’ She grimaced hopefully.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We can ask her.’ Nick nodded. ‘Although I don’t think that was part of her job description when I employed her ten years ago!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini was sure it wasn’t. Rachel James was a woman in her late fifties, and while she used the title of Mrs she had confided in Gemini shortly after she’d come to live here as Nick’s wife, that it was a courtesy title only, useful in the profession she had chosen for herself, but that she’d never actually been married.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Which meant she’d probably never had to deal much with children, either, and in particularly not a very young baby!")])]), _c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’ll have a talk to her in the morning,’ Gemini assured Nick dismissively. ‘But I don’t think Mrs James will mind.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No,’ he acknowledged dryly. ‘I had visions of there being problems with Mrs James when you came to live here as my wife,’ he explained at Gemini’s questioning look, ‘but in fact it’s turned out to be the opposite! Mrs James always comes to you for instructions,’ he murmured ruefully. ‘Fills the house with daffodils at all times of the year because she knows they’re your favourite flower, prepares the meals she knows you like—’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If any of that is a problem for you, Nick, you should have said,’ Gemini put in uncomfortably; she hadn’t even realised he had noticed those slight but subtle changes in the household.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She’d only mentioned once in passing to the housekeeper that she loved daffodils, that their golden colour always made her feel in a cheerful mood—and before she knew it the house was ablaze with the beautiful blooms. Just as she had once mentioned that she preferred to eat fish and chicken to red meat—only to find that red meat all but disappeared from their dining table!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Oh, it isn’t a problem, Gemini,’ Nick assured her derisively. ‘I merely look on in admiration at the charm you’ve exerted over our formerly austere housekeeper.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It wasn’t a question of charming the older woman; she merely treated Rachel James like a person. She hadn’t grown up in a household that had had employees in the house of any kind. She’d lived on her own in a flat before marrying Nick. She wasn’t accustomed to having staff in her home. Rachel had somehow sensed that in her, and had helped her all she could, forging a bond of understanding between the two women that Nick probably couldn’t understand.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page32"
    }
  }, [_vm._v("Nick raised dark brows. ‘How is it you’ve never at")]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_vm._v("tempted to exert that charm over me…?’ he prompted huskily.")])]), _c('a', {
    attrs: {
      "id": "page33"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini gave him a sharp look. Was he flirting with her?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For the most part, Gemini and her husband lived together quite comfortably, with a friendly politeness between them. And Nick rarely, if ever, made any sort of remark that stepped over that line of friendship, that could be taken as being in the least flirtatious. And yet this evening he’d done so more than once…")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Don’t overreact, Gemini, she inwardly warned herself, her pulse beating fast, totally aware of every muscle and sinew of Nick’s near-naked body, able to smell the aftershave that was such a part of him as he stood only feet away from her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But it was very late, that time of the night when nothing seemed quite as it usually was, and Nick probably didn’t mean anything at all by the remark he had just made. In fact, it was probably all the talk of Jemima that had prompted it!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She gave a self-deprecating smile. ‘Probably because I know I would be wasting my time!’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I wouldn’t be too sure of that,’ he murmured throatily.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I would,’ she assured him flatly, all too aware of how he felt about her sister.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Why don’t you try it and see?’ he encouraged softly, seeming suddenly closer now, although Gemini hadn’t been aware of him moving.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini was more sure than ever that he was confusing her with Jemima. ‘You don’t really—’ She broke off as she heard the sound of Jessica’s whimpering cry coming from upstairs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Saved by the bell—or in this case the baby,’ Nick drawled. ‘I think Jessica has decided it’s time for a feed, after all,’ he muttered dryly.")])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Gemini, for one, didn’t know if she was relieved or disappointed at the interruption!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was something different about Nick tonight, on his return from this business trip. He was exerting a sensuality over her that she would have to be totally uninterested not to be aware of—and she was far from being that!")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘You warm a bottle and take it up to her; I’ll turn the lights off down here when I come up,’ Nick told Gemini briskly as he turned away, and that air of intimacy that had briefly been between them was totally dispelled at the return of his usual terseness.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Gemini grabbed the bottle from the kitchen and hurried up the stairs, all the time aware that Nick was still in the sitting-room, where she’d left him.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("What had happened between them just now? she wondered as she fed the baby. And had it really happened "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("between")]), _vm._v(" them, or had Nick briefly allowed her similarity to Jemima in looks to deceive him…?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Somehow—sadly—she had the feeling the latter was the true explanation…!")])])]), _c('a', {
    attrs: {
      "id": "page34"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page34"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-240c83fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781459204560_ch02.vue
// module id = 84
// module chunks = 0